import "react-resizable/css/styles.css";
import StudentClassBody from "./StudentClassBody";
import StudentClassTable from "./StudentClassTable";
import StudentClassProvider from "src/provider/studentClassProvider";
import RegularClassProvider from "src/provider/regularClassProvider";
import TuitionFeesProvider from "src/provider/tuitionFeesProvider";

const StudentClass = ({
  memberData,
  readOnly,
  setReadOnly,
  setKey,
  children,
}) => {
  return (
    <div class="container-fluid">
      <TuitionFeesProvider>
        <RegularClassProvider>
          <StudentClassProvider
            {...{
              memberData,
              readOnly,
              setReadOnly,
              isEdit: !readOnly,
              setKey,
            }}
          >
            {children}
            <StudentClassBody />
            <StudentClassTable />
          </StudentClassProvider>
        </RegularClassProvider>
      </TuitionFeesProvider>
    </div>
  );
};

export default StudentClass;
